<template>
  <div :id="id" class="h-40"/>
</template>

<script setup>
import Highcharts from "@/highcharts"
import colors from "@/colors"
import { onMounted } from "vue"

const props = defineProps({
  id: { type: String, required: true },
  school: { type: Object, required: true },
  partTime: { type: Boolean },
})

onMounted(() => {
  const grants = props.partTime ? props.school.grants_by_percent_pt : props.school.grants_by_percent_ft

  const data = [
    ["No discount", grants.none],
    ["< 50% tuition", grants.less_than_half],
    ["50% - 99% tuition", grants.more_than_half_less_than_full],
    ["Full tuition", grants.full],
    ["More than full tuition", grants.more_than_full],
  ]

  const chartData = {
    chart: {
      renderTo: "grantDonut",
      backgroundColor: "transparent",
      plotBorderWidth: null,
      plotShadow: false,
      margin: [0, 0, 0, 0],
      spacing: [0, 0, 0, 0],
    },
    colors: [colors.orange[500], colors.green["300"], colors.green["400"], colors.green["600"], colors.green["800"]],
    title: {
      text: "",
      verticalAlign: "bottom",
      style: { fontFamily: "Roboto" },
    },
    tooltip: {
      enabled: true,
      crop: false, overflow: "allow", useHTML: true,
      formatter() {
        return `<span style="font-size: 10px"><span style="color:${this.point.color}">\u25CF</span> ${this.key}</span><b style="display:block;text-align:center;font-size:16px;">${this.y}%</b>`
      },
    },
    plotOptions: {
      pie: {
        shadow: false,
        allowPointSelect: false,
        cursor: "pointer",
        dataLabels: {
          enabled: false,
        },
        center: ["50%", "50%"],
      },
    },
    series: [{
      type: "pie",
      size: "100%", innerSize: "50%",
      animation: false,
      states: { hover: { enabled: false }, inactive: { opacity: .8 } },
      groupPadding: 0,
      pointPadding: 0,
      data,
    }],
    credits: {
      enabled: false,
    },
  }
  new Highcharts.chart(props.id, chartData)
})
</script>
